import {
  StyledThemeActivitiesColumn,
  StyledThemeActivitiesRow,
} from './ThemeActivitiesLinks.styled';
import Link from 'next/link';
import Colors from '@/constants/Colors';
import ActivityTypeIcon from '../ActivityTypeIcon/ActivityTypeIcon';
import { pxToVw } from '@/modules/styled/cssUnits';
import { useContext } from 'react';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import useThemeActivitiesLinks from './useThemeActivitiesLinks.hook';
import { useExpandedScreenContext } from '../ThemeDetail/ExpandedScreen/ExpandedScreenContext';
import { getLabelForList } from '@/constants/ActivityTypeLabelsTeacher';

export default function ThemeActivitiesLinks({
  themeActivities,
  layout = 'row',
  linksPrefix = '',
  linkKey = 'slug',
  showFree = false,
  selectedActivityId,
}) {
  const globalContext = useContext(GlobalContext);
  const expandedScreenContext = useExpandedScreenContext();

  const { state } = useThemeActivitiesLinks({
    themeActivities,
  });

  const StyledThemeActivities = {
    row: StyledThemeActivitiesRow,
    column: StyledThemeActivitiesColumn,
  }[layout];

  return (
    <StyledThemeActivities
      key={`${selectedActivityId}-${layout}`}
      className={expandedScreenContext.state?.active ? 'small' : ''}
    >
      {state.activityGroups.map((typeGroup) => {
        return typeGroup.activities.map((activity) => {
          const activityLink = `${linksPrefix}/${activity[linkKey]}`;
          return (
            <Link
              href={activityLink}
              key={activity.id}
              className={`activity ${
                activity.id == selectedActivityId ? 'selected' : ''
              }`}
              passHref
            >
              <ActivityTypeIcon
                type={typeGroup.type}
                freeLabel={
                  showFree &&
                  activity.free &&
                  !globalContext.state.isSubscriptionActive &&
                  !globalContext.state.user?.student
                }
                color="white"
                withCircle
                circleColor={Colors.activityTypeColors[typeGroup.type]}
                size={pxToVw(15)}
                width={pxToVw(46)}
                height={pxToVw(46)}
                className="activity-type-icon"
              />
              <h3 className="activity-type-name">
                {getLabelForList({
                  activity: activity,
                  activities: typeGroup.activities,
                })}
              </h3>
            </Link>
          );
        });
      })}
    </StyledThemeActivities>
  );
}
